import Vue from 'vue'
import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import App from './App.vue'
import './plugins/acl'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import errorHandler from '@/scripts/helpers/error-handling'
import dateFilter from '@/scripts/filters/date-filter'
import currencyFilter from '@/scripts/filters/currency-filter'
import dateDiffFilter from '@/scripts/filters/datediff-filter'

Vue.config.productionTip = false

// Asignamos el error handler de VUE
Vue.config.errorHandler = errorHandler

// Filters
Vue.filter('date', dateFilter)
Vue.filter('currency', currencyFilter)
Vue.filter('datediff', dateDiffFilter)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
